import { Link, useLocation } from "react-router-dom";
import { Clock, AlertTriangle } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function TrialBanner() {
  const { workspace } = useAuth();
  const { pathname } = useLocation();
  const s = workspace?.state;
  if (!s || pathname.startsWith("/billing") || s.status === "active") return null;
  const expired = s.status === "expired" || s.status === "canceled";
  const past = s.status === "past_due";
  const text = expired ? "Your free trial has ended. Pick a plan to keep editing boards, estimates and invites."
    : past ? "Your last payment didn't go through. Update your card to avoid interruption."
    : `${s.trial_days_left} day${s.trial_days_left === 1 ? "" : "s"} left in your free ${s.limits.name} trial.`;
  return (
    <div className={`flex flex-wrap items-center justify-between gap-3 border-b px-6 py-2.5 text-sm ${expired || past ? "bg-destructive/10 text-destructive" : "bg-secondary text-foreground"}`} data-testid="trial-banner">
      <span className="flex items-center gap-2">{expired || past ? <AlertTriangle className="h-4 w-4" /> : <Clock className="h-4 w-4" />}{text}</span>
      <Link to="/billing" className="font-semibold underline-offset-4 hover:underline" data-testid="trial-banner-link">{expired ? "Choose a plan" : past ? "Fix billing" : "See plans"}</Link>
    </div>
  );
}
